export default "__VITE_PUBLIC_ASSET__1697e8ee__"